module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.publicationObject) ? _c('div', {
    staticClass: "publication"
  }, [_c('div', {
    staticClass: "has-text-centered back-button-wrapper"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'AllPublications'
      }
    }
  }, [_vm._v("← К списку публикаций")])], 1), _vm._v(" "), _c('div', {
    staticClass: "publication-header page-header-wrapper",
    style: (_vm.headerStyle)
  }, [_c('div', {
    staticClass: "publication-header-content translucent-wrapper"
  }, [(!_vm.publicationObject.photo) ? _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleLoadPhoto
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Добавить фото\n          "), _c('input', {
    ref: "loadPhotoButton",
    attrs: {
      "type": "file",
      "id": "photo",
      "hidden": ""
    },
    on: {
      "change": _vm.loadPhoto
    }
  })])]) : _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": function($event) {
        return _vm.deletePublicationPhoto(_vm.publicationObject.id)
      }
    }
  }, [_c('a', {
    staticClass: "button is-danger"
  }, [_vm._v("-")]), _vm._v("Удалить фото\n        ")])]), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Название публикации"
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.publicationObject.title),
      callback: function($$v) {
        _vm.$set(_vm.publicationObject, "title", $$v)
      },
      expression: "publicationObject.title"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Подзаголовок публикации"
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.publicationObject.description),
      callback: function($$v) {
        _vm.$set(_vm.publicationObject, "description", $$v)
      },
      expression: "publicationObject.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "publication-text"
  }, [_c('Editor', {
    attrs: {
      "editorToolbar": _vm.customToolbar,
      "placeholder": "Текст публикации"
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "save-content-button centered"
  }, [_c('button', {
    staticClass: "button save-content",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleSave()
      }
    }
  }, [_vm._v(_vm._s(_vm.disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ'))])]), _vm._v(" "), (!_vm.publicationObject.isNew) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column delete-service",
    on: {
      "click": function($event) {
        return _vm.deletePublication(_vm.publicationObject.id)
      }
    }
  }, [_c('span', [_vm._v("Удалить")])])]) : _vm._e()], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7930d764"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About/EditPublication.vue
// module id = 971
// module chunks = 0